export class AuthModel {
  authToken: string;
  // refreshToken: string;
  // expiresIn: Date;
  session: {
    id: number;
    access_token: string;
    user: UserModel;
    role_id: string;
    is_accept: boolean;
  }
  success: boolean;

  setAuth(auth: AuthModel) {
    this.authToken = auth.authToken;
    // this.refreshToken = auth.refreshToken;
    // this.expiresIn = auth.expiresIn;
  }
}

export class UserModel {
  id: number;
  name: string;
  email: string;
  username: string;
  roles: [
    {
      id: number;
      name: string;
      created_at: string;
      updated_at: string;
    }
  ]
}